module.exports = __webpack_public_path__ + "static/media/bug_c.e4fdaddd.svg";